import { atom } from "jotai";

import { additionalDocumentsAtom } from "./additionalDocuments";
import { authoritiesPhotosAtom } from "./authoritiesPhotos";
import { caiPhotosAtom } from "./caiPhotos";
import { damagePhotosAtom } from "./damagePhotos";
import { injuredPeoplePhotosAtom } from "./injuredPeoplePhotos";
import { uploadedPhotosAtom } from "./photosUpload";
import { vehiclePhotosAtom } from "./vehiclePhotos";
import { vinPhotoAtom } from "./vin/vin";

export const clearAllPhotosAtom = atom(null, (_, set, __) => {
  set(damagePhotosAtom, []);
  set(vehiclePhotosAtom, []);
  set(additionalDocumentsAtom, []);
  set(uploadedPhotosAtom, {});
  set(vinPhotoAtom, []);
  set(caiPhotosAtom, []);
  set(injuredPeoplePhotosAtom, []);
  set(authoritiesPhotosAtom, []);
});
